import { Component, OnInit } from '@angular/core';
import { NgbActiveModal, NgbDate, NgbDatepickerNavigateEvent, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { GuiService } from '../_services/gui-service/gui.service';
import { InputService } from '../_services/input/input.service';
import { DateUtils } from '../_commons/date-utils';
import { ThdInput } from '../_models/thd-input';
import { ModalService } from '../_services/modal/modal.service';
import { ThdMonitoringService } from '../_services/thd-monitoring-service/thd-monitoring.service';
import { TranslateService } from '@ngx-translate/core';
import { ConfigurationService } from '../_services/configuration/configuration.service';

@Component({
  selector: 'app-thd-monitoring',
  templateUrl: './thd-monitoring.component.html',
  styleUrls: ['./thd-monitoring.component.css']
})
export class ThdMonitoringComponent implements OnInit {
  dateSelectedYear: number;
  public datesWithMeasurements: Array<String> = new Array<String>();

  fromDate = this.inputService.getDefaultDate("fromDateDefault");
  toDate = this.inputService.getDefaultDate("toDateDefault");
  private topology: any;

  public thdMonitoringSuccessTitle: string = "";
  public thdMonitoringSuccessText: string = "";
  public thdMonitoringFailureTitle: string = "";
  public thdMonitoringFailureText: string = "";

  private enableDataAvailabilityCheck: boolean;

  constructor(
    public activeModal: NgbActiveModal,
    private guiService: GuiService,
    private inputService: InputService,
    private dateUtils: DateUtils,
    private modalService: ModalService,
    private thdMonitoringService: ThdMonitoringService,
    private translationService: TranslateService,
    private configurationService: ConfigurationService,
  ) {
    this.topology = JSON.parse(localStorage.getItem("currentTopology"));
    const language = localStorage.getItem("Language");
    this.translationService.getTranslation(language).subscribe((translations) => {
      this.thdMonitoringSuccessTitle = translations["thd-monitoring"]["71725dfe-1ec3-4b86-b1ca-e1ab47755c0c"];
      this.thdMonitoringSuccessText = translations["thd-monitoring"]["4e95b9ff-3118-4b2c-8795-cb51017393e0"];
      this.thdMonitoringFailureTitle = translations["thd-monitoring"]["6221d21c-0c8c-4504-8306-91f114e48854"];
      this.thdMonitoringFailureText = translations["thd-monitoring"]["ffe170af-7b56-4bd3-b877-567ccf799b18"];
    })
    this.enableDataAvailabilityCheck = this.configurationService.getConfiguration().enableDataAvailabilityCheck;
  }

  ngOnInit() {

  }

  onNavigateDate(event: NgbDatepickerNavigateEvent) {
    const nextYear: number = event.next.year;
    if (!this.dateSelectedYear || nextYear != this.dateSelectedYear) {
      this.dateSelectedYear = nextYear;
      let offset = new Date().getTimezoneOffset();
      
      if (this.enableDataAvailabilityCheck) {
        this.guiService.getMeasurementData(nextYear, offset).subscribe((dates: Array<String>) => {
          console.log(dates);
          this.datesWithMeasurements = dates;
        }), (error) => {
          error.console.error();
        };
      }
    }
  }

  isRange(date: NgbDateStruct) {
    let month: string = "" + date.month;
    if (month.length == 1) {
      month = "0" + month;
    }
    let day: string = "" + date.day;
    if (day.length == 1) {
      day = "0" + day;
    }

    const currentDate: string = date.year + "-" + month + "-" + day;
    if (this.datesWithMeasurements) {
      if (this.datesWithMeasurements.indexOf(currentDate) == -1) {
        return false;
      } else {
        return true;
      }
    }
  }

  /**
   * Check selected date range
   * The method return true when the "fromDate" is previous of "toDate",
   * and return false in all other cases
   * @returns Boolean (true/false)
   */
  checkSelectedRangeDate() {
    if (this.fromDate && this.toDate) {
      let fDate = new NgbDate(this.fromDate.year, this.fromDate.month, this.fromDate.day)
      let tDate = new NgbDate(this.toDate.year, this.toDate.month, this.toDate.day)
      if (tDate.after(fDate) || fDate.equals(tDate)) {
        return false
      }
      else {
        return true
      }
    }
    else {
      return true
    }
  }

  runThdMonitoring(){
    console.log(this.fromDate);
    console.log(this.toDate);
    let fromDate;
    let toDate;
    if(this.fromDate.year && this.fromDate.month && this.fromDate.day && this.toDate.year && this.toDate.month && this.toDate.day){
      fromDate = this.dateUtils.dateStringToString1(this.fromDate.year, this.fromDate.month, this.fromDate.day);
      toDate = this.dateUtils.dateStringToString1(this.toDate.year, this.toDate.month, this.toDate.day);
    }else{
      return;
    }
    this.activeModal.dismiss('THDStarted');
    const thdInput: ThdInput = new ThdInput();
    thdInput.topologyId = this.topology.topologyId;
    thdInput.startDate = fromDate;
    thdInput.endDate = toDate;
    console.log("THD is here ", thdInput);

    this.guiService.runThdMonitoring(thdInput, this.thdMonitoringFailureTitle, this.thdMonitoringFailureText).subscribe((response) => {
      console.log("here is the response: ", response);
      this.thdMonitoringService.receiveThd();
      this.modalService.openBasicAlert(this.thdMonitoringSuccessTitle, this.thdMonitoringSuccessText)
    })
  }
}
